import { useEffect, useMemo, useState } from "react";
import { useHaafFinancialYears } from "@/api/haaf-payments";

export function getFinancialYearId(year) {
  return year?.financialYearId || year?._id || year?.id || "";
}

export function useSelectedHaafFinancialYear() {
  const { data: financialYears, isLoading } = useHaafFinancialYears();
  const [selectedFinancialYearId, setSelectedFinancialYearId] = useState("");

  const defaultFinancialYearId = useMemo(() => {
    const years = financialYears || [];
    const activeYear =
      years.find((year) => year.isActive) ||
      years
        .slice()
        .sort((a, b) => Number(b.startYear || 0) - Number(a.startYear || 0))[0];

    return getFinancialYearId(activeYear);
  }, [financialYears]);

  useEffect(() => {
    if (!selectedFinancialYearId && defaultFinancialYearId) {
      setSelectedFinancialYearId(defaultFinancialYearId);
    }
  }, [defaultFinancialYearId, selectedFinancialYearId]);

  return {
    financialYears: financialYears || [],
    isFinancialYearsLoading: isLoading,
    selectedFinancialYearId,
    setSelectedFinancialYearId,
  };
}
